import Api from "../Api";
import Confirm from "../components/Confirm";

class BaseView {
    constructor() {
        this.formSelector = '';
        this.formUrl = '';
        this.formTpl = '';
        this.formTitle = '';
        this.modalClasses = '';
        this.defaultObject = {};
        this.formCallback = function () {
        };
        this.app = $('[data-app]').data('app');
        this.org = $('[data-org]').data('org');
    }

    init() {
        this.setEvents();
    }

    renderForm(obj,special = null) {
        const self = this;
        let method, url;
        if(special != null)
        {
            method = 'post';
            url = this.formUrl;
        }else
        {
            if (!obj) {
                obj = this.defaultObject;
                method = 'post';
                url = this.formUrl;
            } else {
                method = 'patch';
                url = `${this.formUrl}/${obj._id}`;
            }
    
        }
        
        Api.getTpl(this.formTpl).done(function (r) {
            const tpl = _.template(r);

            Confirm({
                ok: Lang.save,
                title: self.formTitle,
                msg: tpl({item: obj}),
                classes: self.modalClasses,
                onValidate: function () {
                    return self.validateForm();
                },
                onConfirm: function () {
                    const data = self.getFormData();
                    Api.send(url, data, method).done(function () {
                        self.formCallback();
                    });

                }
            });
        });
    }

    getFormData() {
        return $(this.formSelector).aeroSerialize();
    }

    validateForm() {
        return $(this.formSelector).isFormValid();
    }

    setEvents() {
    }
}

export default BaseView;